import { render, staticRenderFns } from "./MemberCenterProfile.vue?vue&type=template&id=0da68d48&scoped=true&"
import script from "./MemberCenterProfile.vue?vue&type=script&lang=js&"
export * from "./MemberCenterProfile.vue?vue&type=script&lang=js&"
import style0 from "./MemberCenterProfile.vue?vue&type=style&index=0&id=0da68d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da68d48",
  null
  
)

export default component.exports